{
  "name": "sharp",
  "description": "High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP, GIF, AVIF and TIFF images",
  "version": "0.31.3",
  "author": "Lovell Fuller <npm@lovell.info>",
  "homepage": "https://github.com/lovell/sharp",
  "contributors": [
    "Pierre Inglebert <pierre.inglebert@gmail.com>",
    "Jonathan Ong <jonathanrichardong@gmail.com>",
    "Chanon Sajjamanochai <chanon.s@gmail.com>",
    "Juliano Julio <julianojulio@gmail.com>",
    "Daniel Gasienica <daniel@gasienica.ch>",
    "Julian Walker <julian@fiftythree.com>",
    "Amit Pitaru <pitaru.amit@gmail.com>",
    "Brandon Aaron <hello.brandon@aaron.sh>",
    "Andreas Lind <andreas@one.com>",
    "Maurus Cuelenaere <mcuelenaere@gmail.com>",
    "Linus Unnebäck <linus@folkdatorn.se>",
    "Victor Mateevitsi <mvictoras@gmail.com>",
    "Alaric Holloway <alaric.holloway@gmail.com>",
    "Bernhard K. Weisshuhn <bkw@codingforce.com>",
    "Chris Riley <criley@primedia.com>",
    "David Carley <dacarley@gmail.com>",
    "John Tobin <john@limelightmobileinc.com>",
    "Kenton Gray <kentongray@gmail.com>",
    "Felix Bünemann <Felix.Buenemann@gmail.com>",
    "Samy Al Zahrani <samyalzahrany@gmail.com>",
    "Chintan Thakkar <lemnisk8@gmail.com>",
    "F. Orlando Galashan <frulo@gmx.de>",
    "Kleis Auke Wolthuizen <info@kleisauke.nl>",
    "Matt Hirsch <mhirsch@media.mit.edu>",
    "Matthias Thoemmes <thoemmes@gmail.com>",
    "Patrick Paskaris <patrick@paskaris.gr>",
    "Jérémy Lal <kapouer@melix.org>",
    "Rahul Nanwani <r.nanwani@gmail.com>",
    "Alice Monday <alice0meta@gmail.com>",
    "Kristo Jorgenson <kristo.jorgenson@gmail.com>",
    "YvesBos <yves_bos@outlook.com>",
    "Guy Maliar <guy@tailorbrands.com>",
    "Nicolas Coden <nicolas@ncoden.fr>",
    "Matt Parrish <matt.r.parrish@gmail.com>",
    "Marcel Bretschneider <marcel.bretschneider@gmail.com>",
    "Matthew McEachen <matthew+github@mceachen.org>",
    "Jarda Kotěšovec <jarda.kotesovec@gmail.com>",
    "Kenric D'Souza <kenric.dsouza@gmail.com>",
    "Oleh Aleinyk <oleg.aleynik@gmail.com>",
    "Marcel Bretschneider <marcel.bretschneider@gmail.com>",
    "Andrea Bianco <andrea.bianco@unibas.ch>",
    "Rik Heywood <rik@rik.org>",
    "Thomas Parisot <hi@oncletom.io>",
    "Nathan Graves <nathanrgraves+github@gmail.com>",
    "Tom Lokhorst <tom@lokhorst.eu>",
    "Espen Hovlandsdal <espen@hovlandsdal.com>",
    "Sylvain Dumont <sylvain.dumont35@gmail.com>",
    "Alun Davies <alun.owain.davies@googlemail.com>",
    "Aidan Hoolachan <ajhoolachan21@gmail.com>",
    "Axel Eirola <axel.eirola@iki.fi>",
    "Freezy <freezy@xbmc.org>",
    "Daiz <taneli.vatanen@gmail.com>",
    "Julian Aubourg <j@ubourg.net>",
    "Keith Belovay <keith@picthrive.com>",
    "Michael B. Klein <mbklein@gmail.com>",
    "Jordan Prudhomme <jordan@raboland.fr>",
    "Ilya Ovdin <iovdin@gmail.com>",
    "Andargor <andargor@yahoo.com>",
    "Paul Neave <paul.neave@gmail.com>",
    "Brendan Kennedy <brenwken@gmail.com>",
    "Brychan Bennett-Odlum <git@brychan.io>",
    "Edward Silverton <e.silverton@gmail.com>",
    "Roman Malieiev <aromaleev@gmail.com>",
    "Tomas Szabo <tomas.szabo@deftomat.com>",
    "Robert O'Rourke <robert@o-rourke.org>",
    "Guillermo Alfonso Varela Chouciño <guillevch@gmail.com>",
    "Christian Flintrup <chr@gigahost.dk>",
    "Manan Jadhav <manan@motionden.com>",
    "Leon Radley <leon@radley.se>",
    "alza54 <alza54@thiocod.in>",
    "Jacob Smith <jacob@frende.me>",
    "Michael Nutt <michael@nutt.im>",
    "Brad Parham <baparham@gmail.com>",
    "Taneli Vatanen <taneli.vatanen@gmail.com>",
    "Joris Dugué <zaruike10@gmail.com>",
    "Chris Banks <christopher.bradley.banks@gmail.com>",
    "Ompal Singh <ompal.hitm09@gmail.com>",
    "Brodan <christopher.hranj@gmail.com",
    "Ankur Parihar <ankur.github@gmail.com>",
    "Brahim Ait elhaj <brahima@gmail.com>",
    "Mart Jansink <m.jansink@gmail.com>"
  ],
  "scripts": {
    "install": "(node install/libvips && node install/dll-copy && prebuild-install) || (node install/can-compile && node-gyp rebuild && node install/dll-copy)",
    "clean": "rm -rf node_modules/ build/ vendor/ .nyc_output/ coverage/ test/fixtures/output.*",
    "test": "npm run test-lint && npm run test-unit && npm run test-licensing",
    "test-lint": "semistandard && cpplint",
    "test-unit": "nyc --reporter=lcov --reporter=text --check-coverage --branches=100 mocha",
    "test-licensing": "license-checker --production --summary --onlyAllow=\"Apache-2.0;BSD;ISC;MIT\"",
    "test-leak": "./test/leak/leak.sh",
    "docs-build": "documentation lint lib && node docs/build && node docs/search-index/build",
    "docs-serve": "cd docs && npx serve",
    "docs-publish": "cd docs && npx firebase-tools deploy --project pixelplumbing --only hosting:pixelplumbing-sharp"
  },
  "main": "lib/index.js",
  "files": [
    "binding.gyp",
    "install/**",
    "lib/**",
    "src/**"
  ],
  "repository": {
    "type": "git",
    "url": "git://github.com/lovell/sharp"
  },
  "keywords": [
    "jpeg",
    "png",
    "webp",
    "avif",
    "tiff",
    "gif",
    "svg",
    "jp2",
    "dzi",
    "image",
    "resize",
    "thumbnail",
    "crop",
    "embed",
    "libvips",
    "vips"
  ],
  "dependencies": {
    "color": "^4.2.3",
    "detect-libc": "^2.0.1",
    "node-addon-api": "^5.0.0",
    "prebuild-install": "^7.1.1",
    "semver": "^7.3.8",
    "simple-get": "^4.0.1",
    "tar-fs": "^2.1.1",
    "tunnel-agent": "^0.6.0"
  },
  "devDependencies": {
    "async": "^3.2.4",
    "cc": "^3.0.1",
    "documentation": "^14.0.1",
    "exif-reader": "^1.0.3",
    "extract-zip": "^2.0.1",
    "icc": "^2.0.0",
    "license-checker": "^25.0.1",
    "mocha": "^10.2.0",
    "mock-fs": "^5.2.0",
    "nyc": "^15.1.0",
    "prebuild": "^11.0.4",
    "rimraf": "^3.0.2",
    "semistandard": "^16.0.1"
  },
  "license": "Apache-2.0",
  "config": {
    "libvips": "8.13.3",
    "integrity": {
      "darwin-arm64v8": "sha512-xFgYt7CtQSZcWoyUdzPTDNHbioZIrZSEU+gkMxzH4Cgjhi4/N49UsonnIZhKQoTBGloAqEexHeMx4rYTQ2Kgvw==",
      "darwin-x64": "sha512-6SivWKzu15aUMMohe0wg7sNYMPETVnOe40BuWsnKOgzl3o5FpQqNSgs+68Mi8Za3Qti9/DaR+H/fyD0x48Af2w==",
      "linux-arm64v8": "sha512-b+iI9V/ehgDabXYRQcvqa5CEysh+1FQsgFmYc358StCrJCDahwNmsQdsiH1GOVd5WaWh5wHUGByPwMmFOO16Aw==",
      "linux-armv6": "sha512-zRP2F+EiustLE4bXSH8AHCxwfemh9d+QuvmPjira/HL6uJOUuA7SyQgVV1TPwTQle2ioCNnKPm7FEB/MAiT+ug==",
      "linux-armv7": "sha512-6OCChowE5lBXXXAZrnGdA9dVktg7UdODEBpE5qTroiAJYZv4yXRMgyDFYajok7du2NTgoklhxGk8d9+4vGv5hg==",
      "linux-x64": "sha512-OTmlmP2r8ozGKdB96X+K5oQE1ojVZanqLqqKlwDpEnfixyIaDGYbVzcjWBNGU3ai/26bvkaCkjynnc2ecYcsuA==",
      "linuxmusl-arm64v8": "sha512-Qh5Wi+bkKTohFYHzSPssfjMhIkD6z6EHbVmnwmWSsgY9zsUBStFp6+mKcNTQfP5YM5Mz06vJOkLHX2OzEr5TzA==",
      "linuxmusl-x64": "sha512-DwB4Fs3+ISw9etaLCANkueZDdk758iOS+wNp4TKZkHdq0al6B/3Pk7OHLR8a9E3H6wYDD328u++dcJzip5tacA==",
      "win32-arm64v8": "sha512-96r3W+O4BtX602B1MtxU5Ru4lKzRRTZqM4OQEBJ//TNL3fiCZdd9agD+RQBjaeR4KFIyBSt3F7IE425ZWmxz+w==",
      "win32-ia32": "sha512-qfN1MsfQGek1QQd1UNW7JT+5K5Ne1suFQ2GpgpYm3JLSpIve/tz2vOGEGzvTVssOBADJvAkTDFt+yIi3PgU9pA==",
      "win32-x64": "sha512-eb3aAmjbVVBVRbiYgebQwoxkAt69WI8nwmKlilSQ3kWqoc0pXfIe322rF2UR8ebbISCGvYRUfzD2r1k92RXISQ=="
    },
    "runtime": "napi",
    "target": 7
  },
  "engines": {
    "node": ">=14.15.0"
  },
  "funding": {
    "url": "https://opencollective.com/libvips"
  },
  "binary": {
    "napi_versions": [
      7
    ]
  },
  "semistandard": {
    "env": [
      "mocha"
    ]
  },
  "cc": {
    "linelength": "120",
    "filter": [
      "build/include"
    ]
  }
}
